/** Grymwyrd traduction française pour le héros de la page d'accueil. */
export const homeFr = {
  'home.heroEyebrow': 'Un monde d\'horreur-fantastique vivant',
  'home.heroTitle': 'Entre dans le Crépuscule',
  'home.heroBody':
    'Grymwyrd est un monde de terreur gothique victorienne, où la ville engloutie par le brouillard de Greywick cache des tours en ruines, des cryptes seigneuriales et des rituels qu\'il vaut mieux ne pas prononcer. Forge un héros, lève les voiles du Cataclysme et grave ton nom dans un monde qui se souvient.',
  'home.heroPlayCta': 'Jouer maintenant',
  'home.heroBrowseCta': 'Parcourir l\'encyclopédie',
  'home.heroQuickstartPrompt': 'Pas prêt à jouer ? Obtiens le Quickstart gratuit',
}
